import { z } from 'zod/v3';
import { ChangedByDto } from '../../user';
import { SortSchema } from '../utils/schema/paginationSchema';

export interface Entity<ID = number> {
  id: ID;
  createdAt: string | null; // datetime
  createdBy: ChangedByDto | null;
  modifiedAt: string | null; // datetime
  modifiedBy: ChangedByDto | null;
}

export interface EntityWithName<ID = number> extends Entity<ID> {
  name: string;
}

export interface Page<T> {
  content: T[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number; // 0-based
  size: number;
  totalElements: number;
  totalPages: number;
  sort: z.infer<typeof SortSchema>;
}

export const EMPTY_PAGE: Page<any> = {
  content: [],
  empty: true,
  first: true,
  last: true,
  number: 0,
  size: 0,
  totalElements: 0,
  totalPages: 0,
  sort: [] as unknown as z.infer<typeof SortSchema>,
};

export interface PageRequestParams<S extends string = string> {
  page?: number; // 0-based
  size?: number;
  sort?: Sort<S>;
}

export const AUTOCOMPLETE_PAGE_SIZE = 20;

export interface OptionType {
  label?: string;
  value?: string | number | null;
}

export interface OptionsPage<T extends OptionType = OptionType> {
  content: T[];
  last: boolean;
  number: number;
}

export type Sort<S extends string = string> = SortField<S> | SortField<S>[];

export type SortField<S extends string = string> = S | `${S},${Order}`;

export type Order = 'asc' | 'desc';
